module.exports = __webpack_public_path__ + "static/img/103460.20d37df6.png";